<template lang="pug">
.c-gallery
  div(:class="$style.thumbbox")
    base-thumb(v-for="(src, i) in thumbs"
      :key="src"
      :src="src"
      @click.native="selectThumb(i)")
  b-modal(:class="$style.modal"
    :active.sync="reader"
    custom-class="modal")
    gallery-reader(:items="items"
      :current.sync="current"
      @select:thumb="current = $event")
</template>

<script>
import BaseThumb from "@/components/BaseThumb.vue";
import GalleryReader from "@/components/GalleryReader.vue";
import ThumbRow from "@/components/ThumbRow.vue";
import BaseUrlProvider from "@/components/BaseUrlProvider.vue";

export default {
  name: "Gallery",
  components: {
    BaseThumb,
    GalleryReader,
    ThumbRow,
    BaseUrlProvider
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      reader: false,
      current: 0
    };
  },
  computed: {
    thumbs() {
      return this.items ? this.items.map(item => item.thumbSrc) : [];
    }
  },
  methods: {
    selectThumb(index) {
      this.reader = true;
      this.current = index;
    }
  }
};
</script>

<style module lang="sass">
.thumbbox
  +flexbox(center, flex-start)
  +wrap

.thumb
  +size(110px, 110px)
  margin: 5px
  border-radius: 6px
  overflow: hidden

.modal :global(.modal-content)
  max-height: none
  overflow: hidden

.wrapper
  +flexbox(center, center, column)

.core
  position: relative
  width: 600px
  max-width: 100%

.main
  width: 100%
  img
    +size(100%, 100%)
    object-fit: contain

.button
  +size(64px, 64px)
  +abCenter(y)
  +rounded
  +flexbox(center, center)
  +pointer
  background-color: white
  font-size: 36px
  +mobile
    display: none

.left
  left: -100px

.right
  right: -100px
</style>
